// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { InfiniteScroll, Picker, Popup } from 'mint-ui'
import axios from 'axios'
import qs from 'qs'

axios.defaults.baseURL = '/wx/wechat/'
axios.defaults.timeout = 15000
axios.defaults.headers.crossDomain = true
axios.defaults.withCredentials = true
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'

const api = axios.create()

// 添加请求拦截
api.interceptors.request.use(function (config) {
  let token = ''
  let account = ''
  try {
    token = (JSON.parse(window.sessionStorage.getItem('token') || '{}')).token
    account = (JSON.parse(window.sessionStorage.getItem('account') || '{}')).account
  } catch (err) {
    console.log(err)
  }
  config.headers.token = token
  config.headers.account = account
  config.paramsSerializer = function (params) {
    let param = params || {}
    // param.timestamp = (new Date()).getTime()
    param = qs.stringify(param, {arrayFormat: 'repeat'})
    return param
  }
  return config
}, function (error) {
  console.log(error)
  return Promise.reject(error)
})

// 添加响应拦截器
api.interceptors.response.use(function (response) {
  if (response.data.code === 5104) {
    router.push('/')
  } else if (response.data.code === 5105) {
    router.push('/admin')
  } else {
    return response.data
  }
}, function (error) {
  console.log(error)
  return Promise.reject(error.message)
})

Vue.use(InfiniteScroll)
Vue.component(Picker.name, Picker)
Vue.component(Popup.name, Popup)

Vue.config.productionTip = false
Vue.prototype.$api = api

Vue.mixin({
  data () {
    return {
      openId: ''
    }
  },
  methods: {
    getRequest () {
      let url = window.location.href
      let theRequest = {}
      if (url.indexOf('?') !== -1) {
        let str = url.split('?')[1]
        let strs = str.split('&')
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
        }
      }
      return theRequest
    },
    setSession (key, obj) {
      window.sessionStorage.setItem(key, JSON.stringify({
        [key]: obj
      }))
    },
    getSession (key) {
      let _res = JSON.parse(window.sessionStorage.getItem(key) || '{}')
      return _res[key]
    },
    fixWxScrollBug () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
  mounted () {
    document.addEventListener('blur', this.fixWxScrollBug, true)
    document.body.querySelector('#app').style.height = window.innerHeight + 'px'
  },
  created () {
    let _openId = this.getRequest().openid
    if (_openId) {
      this.openId = _openId
      this.setSession('openId', _openId)
    } else {
      this.openId = this.getSession('openId') || '999'
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js